import React from 'react';
//create authenticated user context to share globally between comps
const AuthUserContext = React.createContext(null);
export default AuthUserContext;
